import React from "react";
import "./component-styles.scss";

function Welcome(props) {
  return (
    <div className="mr-2">
      <h3 className="welcome-text">Welcome Back,</h3>
      <h4 className="header-text">{props.doctorFullName}</h4>
    </div>
  );
}

export default Welcome;
